import React, { FC, useEffect, useState } from 'react';
import DriverCard from './components/card';
import Modal from './components/modal';
import Exit from './components/exit';
import { Grid, IconButton, Paper } from '@material-ui/core';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
// import useQuery from '../../utils/hook/useQuery';
import { removeEmptyValueObject } from '../../utils/helpers';
import Icon from '@mdi/react';
import { mdiAccountCircle } from '@mdi/js';
import { flattenObject } from '../../utils/helpers';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import { getOrdersAction, changeOrdersStatusAction } from './actions';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectCountOrdersList,
  makeSelectError,
  makeSelectLoading,
  makeSelectOrdersList,
} from './selectors';
import {
  // Props,
  // SelectorProps,
  Payload,
} from './interfaces';
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  ResponderProvided,
  DraggableProvided,
  DroppableProvided,
  DraggableStateSnapshot,
} from 'react-beautiful-dnd';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      //   textAlign: 'center',
      //   display:'flex',
      //   justifyContent:'center',
      //   margin: '10px auto',
      //   alignContent: 'center',
      //   alignItems: 'center',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#4D4D4D',
      // justifyContent: 'center',
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    right: {
      textAlign: 'right',
      padding: '8px 13px',
      alignItems: 'center',
    },
    left: {
      textAlign: 'left',
      padding: '8px 0',
      alignItems: 'center',
    },
    paper: {
      width: '90%',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
    },
    searchBox: {},
    orderNumber: {
      alignItems: 'center',
      textAlign: 'center',
      display: 'inline-block',
      marginTop: '12px',
    },
  })
);

const DriverManagement: FC = (props: any) => {
  const classes = useStyles();
  const [filtersValues, setFiltersValues] = useState({} as any);
  const [modalType, setModalType] = useState<string>('');
  const [idCard, setIdCard] = useState<number>();
  const [cod, setCod] = useState({});
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openExitModal, setOpenExitModal] = useState<boolean>(false);
  const [localItems, setLocalItems] = React.useState([]);
  useEffect(() => {
    getOrdersHandler();
  }, [filtersValues]);
  const deliveredHandler = (id: number, type: string, codPaymentCode = false, codValue = false) => {
    setModalType(type);
    setIdCard(id);
    setOpenModal(true);
    setCod({ codPaymentCode, codValue });
  };
  const getOrdersHandler = () => {
    props.ordersDispatch(
      flattenObject({
        ...filtersValues,
        sort: 'id,desc',
        'status.in': ['LOADED', 'BUNDLED'],
        size: 100,
      })
    );
  };
  const notDeliveredHandler = (id: number, type: string) => {
    setModalType(type);
    setIdCard(id);
    setOpenModal(true);
  };
  const updateStatusHandler = (text: string, id: number) => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: modalType, description: text },
      pagination: filtersValues,
      callback: () => getOrdersHandler(),
    });
    setOpenModal(false);
  };
  const changeStatusOrder = (id: number) => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: modalType, description: '' },
      pagination: filtersValues,
      callback: () => getOrdersHandler(),
    });
    setOpenModal(false);
  };
  const exitHandler = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('partnerId');
    localStorage.removeItem('warehouseId');
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    window.location.href = '/login';
  };

  //react-beautiful-dnd
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  useEffect(() => {
    setLocalItems(props.ordersList);
  }, [props.ordersList]);
  const handleDragEnd = (result: DropResult, provided?: ResponderProvided) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    setLocalItems((prev: any) => {
      const temp = [...prev];
      const d = temp[result.destination!.index];
      temp[result.destination!.index] = temp[result.source.index];
      temp[result.source.index] = d;

      return temp;
    });
  };
  //react-beautiful-dnd */
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={6}
        style={{ textAlign: 'center', justifyContent: 'center' }}
      >
        <Paper component="div" className={classes.paper}>
          <Grid
            item
            xs={12}
            sm={6}
            alignItems="center"
            className={classes.left}
          >
            <span className={classes.label}>
              <IconButton onClick={() => setOpenExitModal(true)}>
                <Icon
                  path={mdiAccountCircle}
                  size={1}
                  className={classes.icon}
                />
              </IconButton>
              {/* {'احمد احمدی'} */}
            </span>
          </Grid>
          <Grid
            item
            sm={6}
            xs={12}
            alignItems="center"
            className={classes.right}
          >
            <span className={classes.orderNumber}>{'سفارش'}</span>
          </Grid>
        </Paper>
        <Grid
          container
          item
          sm={12}
          xs={12}
          justifyContent="center"
          className={classes.searchBox}
        >
          <RenderFilter
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه سفارش',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid
          container
          item
          sm={12}
          xs={12}
          style={{ textAlign: 'center' }}
          justifyContent="center"
        >
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable" direction="vertical">
              {(droppableProvided: DroppableProvided) => (
                <div
                  ref={droppableProvided.innerRef}
                  {...droppableProvided.droppableProps}
                >
                  {localItems.map((row: any, index: number) => (
                    <Draggable
                      key={row.id}
                      draggableId={row.id + ''}
                      index={index}
                    >
                      {(
                        draggableProvided: DraggableProvided,
                        snapshot: DraggableStateSnapshot
                      ) => {
                        return (
                          <DriverCard
                            data={row}
                            key={index}
                            deliveredHandler={deliveredHandler}
                            notDeliveredHandler={notDeliveredHandler}
                            draggableProvided={draggableProvided}
                            snapshot={snapshot}
                          />
                        );
                      }}
                    </Draggable>
                  ))}
                  {droppableProvided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {idCard && (
            <Modal
              idCard={idCard}
              modalType={modalType}
              updateStatusHandler={updateStatusHandler}
              changeStatusOrder={changeStatusOrder}
              openModal={openModal}
              cod={cod}
              closeModalHandler={() => {
                setOpenModal(false);
              }}
            />
          )}
          <Exit
            openExitModal={openExitModal}
            closeExitHandler={() => setOpenExitModal(false)}
            exitHandler={exitHandler}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  count: makeSelectCountOrdersList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(changeOrdersStatusAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(DriverManagement);
